<div class="flex items-center justify-between">
  <h2 class="text-xl">{{ 'ADMIN_FILTER_TITLE' | localization }}</h2>
  <ui-button type="secondary" size="small" (click)="onFilterClosed()">
    <ui-icon name="close" size="20px"></ui-icon>
  </ui-button>
</div>

<ui-form style="overflow: auto" [form]="form" [config]="formConfig"> </ui-form>
<div style="flex: 1"></div>
<ui-button type="secondary" [block]="true" (click)="resetFilter()">
  <span>{{ 'ADMIN_FILTER_RESET' | localization }}</span>
</ui-button>
<ui-button type="primary" [block]="true" [disabled]="!canApply" (click)="applyFilter()">
  <span>{{ 'ADMIN_FILTER_APPLY' | localization }}</span>
</ui-button>
